    <div class="auth-shell auth-shell-register">
      <aside class="auth-aside">
        <div class="auth-brand">
          <img class="auth-logo" src="/rectangular%20logo.PNG" alt="Central Profile" />
          <span class="eyebrow">Central Profile</span>
          <h2 class="hero-title">Recover, restore, and update your identity trail from one place.</h2>
          <p class="hero-copy">
            Central Profile helps members restore lost contact networks, keep institutions updated,
            and preserve critical personal records across devices.
          </p>
        </div>

        <ul class="auth-points">
          <li>Phone loss and SIM swap recovery workflows</li>
          <li>Institution updates for banking, insurance, retail, and HR</li>
          <li>Contact, SMS, and WhatsApp backup readiness</li>
          <li>OIDC/OAuth2-ready authentication for ASP.NET Core Identity</li>
        </ul>
      </aside>

      <section class="auth-panel">
        <div class="auth-card">
          <span class="eyebrow eyebrow-soft">Secure sign in</span>
          <h2 class="page-title auth-title-spaced">Login</h2>
          <p class="page-subtitle">
            Use your Central Profile account or continue with a trusted provider.
          </p>

          <form class="form-stack" [formGroup]="form" (ngSubmit)="submit()">
            <div class="input-group">
              <label for="email">Username or email</label>
              <input id="email" type="email" formControlName="email" placeholder="you@example.com" />
            </div>

            <div class="input-group">
              <label for="password">Password</label>
              <input id="password" type="password" formControlName="password" placeholder="Enter your password" />
            </div>

            <button class="btn btn-primary" type="submit">Login</button>
          </form>

          <div class="auth-links auth-links-spaced">
            <a routerLink="/register" class="label">Register if you have no account</a>
            <a routerLink="/forgot-password" class="label">Forgot password?</a>
          </div>

          <div class="divider-text divider-spaced">or continue with</div>

          <div class="btn-row">
            <button class="btn btn-provider" type="button" (click)="useProvider('google')">
              <i class="fa-brands fa-google"></i>
              Google
            </button>
            <button class="btn btn-provider" type="button" (click)="useProvider('facebook')">
              <i class="fa-brands fa-facebook-f"></i>
              Facebook
            </button>
            <button class="btn btn-provider" type="button" (click)="useProvider('microsoft')">
              <i class="fa-brands fa-microsoft"></i>
              Microsoft
            </button>
          </div>

          <div class="panel panel-soft-accent panel-spaced-top">
            <strong>OIDC client profile</strong>
            <p class="label label-spaced-top">
              Authority: {{ authService.oidcConfig.authority }}<br />
              Client: {{ authService.oidcConfig.clientId }}<br />
              Scope: {{ authService.oidcConfig.scope }}
            </p>
          </div>
        </div>
      </section>
    </div>
